export default __webpack_public_path__ + "static/media/ic_designation_blue_48px.6a8549fb.svg";